import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getFirestore } from "firebase/firestore";
import {getAuth, GoogleAuthProvider} from "firebase/auth"

const firebaseConfig = {
    apiKey: "AIzaSyBvSzeXwTOzVDy_yWlAXWc3ZrVtAvM23eU",
    authDomain: "tadpole-f221d.firebaseapp.com",
    projectId: "tadpole-f221d",
    storageBucket: "tadpole-f221d.appspot.com",
    messagingSenderId: "277703829351",
    appId: "1:277703829351:web:361b5970c1fbd6442fb1c2",
    measurementId: "G-6X65S5CK0F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firestore instance
export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();